import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function EmptyLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="from-primary to-secondary relative flex h-screen flex-col bg-gradient-to-bl">
      <main className="container mx-auto max-w-7xl flex-grow px-6 pt-16">{children}</main>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}
